import type { ApiService } from "@/hooks/use-api-service/use-api-service";
import { createContext, useContext } from "react";

const ApiServiceContext = createContext<ApiService>({} as ApiService);
const ApiServiceProvider = ApiServiceContext.Provider;
const useApiServiceContext = () => useContext(ApiServiceContext);

export { ApiServiceContext, ApiServiceProvider, useApiServiceContext };
